import { createContext, useContext, useEffect, useState } from "react";

interface ImageViewerSplashContextProps {
    imgUrls : string[];
    setImgUrls : Function;
}

const ImageViewerSplashContext = createContext<ImageViewerSplashContextProps>({} as ImageViewerSplashContextProps);

export const useImageViewerSplashContext = () => {
  const context = useContext(ImageViewerSplashContext);
  if (context === undefined) {
    throw new Error("CustomContext must be used within a CustomContextProvider");
  }
  return context;
};

export const ImageViewerSplashContextProvider: React.FC = ({ children }) => {
    const [imgUrls, setImgUrls] = useState<string[]>([]);

    return (
        <ImageViewerSplashContext.Provider value={{imgUrls, setImgUrls}}>
            {children}
        </ImageViewerSplashContext.Provider>
    );
};

export default ImageViewerSplashContext;